import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Card, CardBody, Table } from 'reactstrap';
import Spinners from '../../components/Common/Spinner';
import { getPurchaseOrderAuditReq, getPurchaseOrderDetailsReq } from '../../service/purchaseService';
import { setBreadcrumbItems } from '../../store/Breadcrumb/actions';
import { formatDate } from '../../utility/formatDate';

const PurchaseOrderTrail = (props) => {
  const { id } = useParams();
  const [auditTrail, setAuditTrail] = useState();
  const [orderInfo, setOrderInfo] = useState()
  const [loading, setLoading] = useState(false)

  const getPurchaseOrderDetails = async () => {
    const response = await getPurchaseOrderDetailsReq(id);
    const rawData = response?.data;
    setOrderInfo(rawData)
  };

  useEffect(() => {
    const fetchAuditData = async () => {
      try {
        setLoading(true)
        const response = await getPurchaseOrderAuditReq(id);
        setAuditTrail(response?.data);
      } catch (e) {
        console.error('Failed to fetch purchase order audit trail', e);
      }
      finally {
        setLoading(false)
      }
    };

    getPurchaseOrderDetails()
    fetchAuditData();
  }, [id]);

  useEffect(() => {
    if (orderInfo?.purchaseOrderNumber) {
      props.setBreadcrumbItems('Trail', [
        { title: 'Dashboard', link: '/dashboard' },
        { title: 'Purchase Orders', link: '/purchase-orders' },
        {
          title: orderInfo.purchaseOrderNumber,
          link: `/purchase-orders/${id}`,
        },
        { title: 'Trail', link: '#' },
      ]);
    }
  }, [orderInfo, id]);

  const latestVersion = auditTrail?.length
    ? Math.max(...auditTrail.map((item) => item.version))
    : null;

  return (
    <Card>
      <CardBody>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Spinners />
          </div>
        ) : (
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>Version</th>
                <th>Edited By</th>
                <th>Updated At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {auditTrail &&
                auditTrail.map((entry) => {
                  const isLatest = entry.version === latestVersion;

                  const name = entry?.changedBy
                    ? `${entry.changedBy.firstName || ''} ${entry.changedBy.lastName || ''}`.trim()
                    : '-';

                  return (
                    <tr key={entry._id}>
                      <td>
                        {`${orderInfo?.purchaseOrderNumber} ${isLatest ? '(current)' : `(v${entry?.version})`
                          }`}
                      </td>

                      <td>{name || '-'}</td>

                      <td>
                        {entry.updatedAt
                          ? formatDate(new Date(entry.updatedAt))
                          : '-'}
                      </td>

                      <td>
                        <Link
                          to={
                            isLatest
                              ? `/purchase-orders/${id}`
                              : `/purchase-orders/${id}/v${entry?.version}/${entry?._id}`
                          }
                          className="btn btn-sm btn-primary"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        )}
      </CardBody>
    </Card>
  );
};

export default connect(null, { setBreadcrumbItems })(PurchaseOrderTrail);
